import { useToast } from '@chakra-ui/react'
import { FC, useRef, useState } from 'react'

import useParametrizationSimilarProduct from '@hook/parametrization/use-similar-product'

import UploadPreviewModal from '@component/Parameterization/SimilarProduct/UploadPreviewModal'

import {
  SimilarProductRow,
  parseSimilarProductCSV,
  validateRows
} from '../../../../../../utils/parametrization/similarProductCsv'
import LayoutToolsButton from '../../Components/Button'

const ActionParametrizationProductSimilarUpload: FC = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [parsedRows, setParsedRows] = useState<SimilarProductRow[]>([])
  const [isUploading, setIsUploading] = useState(false)
  const fileInputRef = useRef<HTMLInputElement>(null)
  const toast = useToast()

  const { postCarga } = useParametrizationSimilarProduct()

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
      fileInputRef.current.click()
    }
  }

  // eslint-disable-next-line no-undef
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = ev => {
      const text = (ev.target?.result as string) ?? ''
      const { rows, parseError } = parseSimilarProductCSV(text)

      if (parseError) {
        toast({
          title: 'Arquivo inválido',
          description: parseError,
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top'
        })
        return
      }

      if (rows.length === 0) {
        toast({
          title: 'Nenhum registro encontrado',
          description: 'O arquivo não contém registros válidos.',
          status: 'warning',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })
        return
      }

      setParsedRows(validateRows(rows))
      setModalOpen(true)
    }
    reader.readAsText(file, 'UTF-8')
    if (fileInputRef.current) fileInputRef.current.value = ''
  }

  const handleConfirm = async (rows: SimilarProductRow[]) => {
    setIsUploading(true)
    try {
      const produtos = rows.map(r => ({
        EmpresaId: Number(r.empresaId),
        ProdutoNovoId: Number(r.produtoNovoId),
        ProdutoSimilarId: Number(r.produtoSimilarId),
        DemandaAbsorvida: r.demanda !== '' ? Number(r.demanda) : 0,
        DataInicio: r.dataInicio,
        DataFim: r.dataFim
      }))
      await postCarga(produtos)
      setModalOpen(false)
    } finally {
      setIsUploading(false)
    }
  }

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept=".csv,text/csv"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />

      <LayoutToolsButton
        label="Upload de arquivo"
        isLoading={false}
        loadingText="Fazendo upload"
        onClick={handleClick}
        isDisabledDefault={false}
      />

      <UploadPreviewModal
        isOpen={modalOpen}
        initialRows={parsedRows}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
        isLoading={isUploading}
      />
    </>
  )
}

export default ActionParametrizationProductSimilarUpload
